module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/icon_tourcoin.6fc9d57d.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/icon_tourcoin.png
// module id = 3009
// module chunks = 11